export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-battery-half-d26af8dacbb020e64f331b409cc40b71.svg";